module.exports = __webpack_public_path__ + "img/files-white.8ddef594.svg";